import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl.js';
import { Button, ButtonGroup } from 'reactstrap';

import { getLoggedUser } from '../../../User/UserActions';
import { getLanguagePath } from '../../../Intl/IntlHelper';

function CmsEditLinks({ intl, content, user = null }) {
	const [mounted, setMounted] = useState(false);
	useEffect(() => {
		setMounted(true);
	}, []);

	return mounted && content?._id && user?.role === 'root' && (
		<ButtonGroup vertical style={{ position: 'fixed', bottom: '50px', right: '10px' }}>
			<Button color="outline-secondary" tag={Link} to={getLanguagePath(`/console/content/${content._id}`, intl.locale)} className="bg-white"><FormattedMessage id="contentEdit" defaultMessage="Edit content" /></Button>
		</ButtonGroup>
	);
}

function mapStateToProps(store, props) {
	return {
		user: getLoggedUser(store),
	};
}

CmsEditLinks.propTypes = {
	intl: PropTypes.object.isRequired,
	content: PropTypes.object.isRequired,
	user: PropTypes.object,
};

export default connect(mapStateToProps)(withIntl(CmsEditLinks));
